/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  DataFieldStatus,
  DataFieldStatusAction,
  DefaultDataFieldId,
  DeleteDataFieldDraftDto,
  GetDataFieldDefaultDraftDto,
  GetDataFieldDefaultPublishedDto,
  GetDataFieldDraftDto,
  GetDataFieldPublishedDto,
  GetDataFieldsDefaultDto,
  GuestActivityDto,
  ListDtoGetDataFieldDraftDto,
  ListDtoGetDataFieldPublishedDto,
  ListDtoGetExternalDataFieldReferenceDto,
  MapString,
  PublishDataFieldDefaultDraftDto,
  PublishDataFieldDraftDto,
  SaveCollectedDataDto,
  SaveGuestCollectedDataDto,
  UpdateDataFieldDefaultDraftDto,
  UpdateDataFieldDraftDto,
  UsageBulkRequestRes,
  UsageRequestRes,
  WrappedLeaseRes,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "chili-crm";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Returns all DataField draft records
   *
   * @name GetAllDataFieldDrafts
   * @request GET:/v1/tenant/{tenantId}/custom/drafts
   * @secure
   */
  getAllDataFieldDrafts = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      ListDtoGetDataFieldDraftDto,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/custom/drafts`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAllDataFieldDrafts */
  getAllDataFieldDraftsPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/custom/drafts`);

  /**
   * @description Creates an empty DataField draft
   *
   * @name CreateNewDataFieldDraft
   * @request POST:/v1/tenant/{tenantId}/custom/drafts
   * @secure
   */
  createNewDataFieldDraft = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      GetDataFieldDraftDto,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/custom/drafts`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createNewDataFieldDraft */
  createNewDataFieldDraftPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/custom/drafts`);

  /**
   * @description Returns draft record
   *
   * @name GetDraftById
   * @request GET:/v1/tenant/{tenantId}/custom/drafts/{dataFieldId}
   * @secure
   */
  getDraftById = (tenantId: string, dataFieldId: string, params: RequestParams = {}) =>
    this.request<
      GetDataFieldDraftDto,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/custom/drafts/${dataFieldId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getDraftById */
  getDraftByIdPathGetter = (tenantId: string, dataFieldId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/custom/drafts/${dataFieldId}`);

  /**
   * @description Updates a draft if exists and unchanged
   *
   * @name UpdateADataFieldDraft
   * @request PUT:/v1/tenant/{tenantId}/custom/drafts/{dataFieldId}
   * @secure
   */
  updateADataFieldDraft = (
    tenantId: string,
    dataFieldId: string,
    data: UpdateDataFieldDraftDto,
    params: RequestParams = {},
  ) =>
    this.request<
      GetDataFieldDraftDto,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/custom/drafts/${dataFieldId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateADataFieldDraft */
  updateADataFieldDraftPathGetter = (tenantId: string, dataFieldId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/custom/drafts/${dataFieldId}`);

  /**
   * @description Deletes a draft if unpublished
   *
   * @name DeleteADataFieldDraft
   * @request DELETE:/v1/tenant/{tenantId}/custom/drafts/{dataFieldId}
   * @secure
   */
  deleteADataFieldDraft = (
    tenantId: string,
    dataFieldId: string,
    data: DeleteDataFieldDraftDto,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/custom/drafts/${dataFieldId}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteADataFieldDraft */
  deleteADataFieldDraftPathGetter = (tenantId: string, dataFieldId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/custom/drafts/${dataFieldId}`);

  /**
   * @description Create a published version of a Draft
   *
   * @name PublishDataFieldDraft
   * @request POST:/v1/tenant/{tenantId}/custom/drafts/{dataFieldId}/publish
   * @secure
   */
  publishDataFieldDraft = (
    tenantId: string,
    dataFieldId: string,
    data: PublishDataFieldDraftDto,
    params: RequestParams = {},
  ) =>
    this.request<
      GetDataFieldPublishedDto,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/custom/drafts/${dataFieldId}/publish`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for publishDataFieldDraft */
  publishDataFieldDraftPathGetter = (tenantId: string, dataFieldId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/custom/drafts/${dataFieldId}/publish`);

  /**
   * @description Republish data field with Enabled or Archived status
   *
   * @name ActivateOrArchiveDataField
   * @request PUT:/v1/tenant/{tenantId}/custom/published/{dataFieldId}/{action}
   * @secure
   */
  activateOrArchiveDataField = (
    tenantId: string,
    dataFieldId: string,
    action: DataFieldStatusAction,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/custom/published/${dataFieldId}/${action}`,
      method: "PUT",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for activateOrArchiveDataField */
  activateOrArchiveDataFieldPathGetter = (tenantId: string, dataFieldId: string, action: DataFieldStatusAction) =>
    this.getServicePath(`/v1/tenant/${tenantId}/custom/published/${dataFieldId}/${action}`);

  /**
   * @description Returns the most recent published DataField record
   *
   * @name GetLatestPublished
   * @request GET:/v1/tenant/{tenantId}/custom/published/{dataFieldId}/latest
   * @secure
   */
  getLatestPublished = (tenantId: string, dataFieldId: string, params: RequestParams = {}) =>
    this.request<
      GetDataFieldPublishedDto,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/custom/published/${dataFieldId}/latest`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getLatestPublished */
  getLatestPublishedPathGetter = (tenantId: string, dataFieldId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/custom/published/${dataFieldId}/latest`);

  /**
   * @description Returns Published records history
   *
   * @name GetAllPublishedById
   * @request GET:/v1/tenant/{tenantId}/custom/published/{dataFieldId}
   * @secure
   */
  getAllPublishedById = (tenantId: string, dataFieldId: string, params: RequestParams = {}) =>
    this.request<
      ListDtoGetDataFieldPublishedDto,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/custom/published/${dataFieldId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAllPublishedById */
  getAllPublishedByIdPathGetter = (tenantId: string, dataFieldId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/custom/published/${dataFieldId}`);

  /**
   * @description Returns all Published records or the most recent versions
   *
   * @name GetAllPublished
   * @request GET:/v1/tenant/{tenantId}/custom/published
   * @secure
   */
  getAllPublished = (
    tenantId: string,
    query?: {
      latest?: boolean;
      status?: DataFieldStatus;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ListDtoGetDataFieldPublishedDto,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/custom/published`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAllPublished */
  getAllPublishedPathGetter = (
    tenantId: string,
    query?: {
      latest?: boolean;
      status?: DataFieldStatus;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/custom/published`, query);

  /**
   * @description Returns draft and published default data fields
   *
   * @name GetAllDefaultDataFields
   * @request GET:/v1/tenant/{tenantId}/defaults/drafts-and-published
   * @secure
   */
  getAllDefaultDataFields = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      GetDataFieldsDefaultDto,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/defaults/drafts-and-published`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAllDefaultDataFields */
  getAllDefaultDataFieldsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/defaults/drafts-and-published`);

  /**
   * @description Returns published default data field
   *
   * @name GetPublishedDefaultDataField
   * @request GET:/v1/tenant/{tenantId}/defaults/published/{dataFieldDefaultId}/latest
   * @secure
   */
  getPublishedDefaultDataField = (
    tenantId: string,
    dataFieldDefaultId: DefaultDataFieldId,
    params: RequestParams = {},
  ) =>
    this.request<
      GetDataFieldDefaultPublishedDto,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/defaults/published/${dataFieldDefaultId}/latest`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getPublishedDefaultDataField */
  getPublishedDefaultDataFieldPathGetter = (tenantId: string, dataFieldDefaultId: DefaultDataFieldId) =>
    this.getServicePath(`/v1/tenant/${tenantId}/defaults/published/${dataFieldDefaultId}/latest`);

  /**
   * @description Updates a default data field draft if exists and unchanged
   *
   * @name UpdateDefaultDataFieldDraft
   * @request PUT:/v1/tenant/{tenantId}/defaults/drafts/{dataFieldDefaultId}
   * @secure
   */
  updateDefaultDataFieldDraft = (
    tenantId: string,
    dataFieldDefaultId: DefaultDataFieldId,
    data: UpdateDataFieldDefaultDraftDto,
    params: RequestParams = {},
  ) =>
    this.request<
      GetDataFieldDefaultDraftDto,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/defaults/drafts/${dataFieldDefaultId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateDefaultDataFieldDraft */
  updateDefaultDataFieldDraftPathGetter = (tenantId: string, dataFieldDefaultId: DefaultDataFieldId) =>
    this.getServicePath(`/v1/tenant/${tenantId}/defaults/drafts/${dataFieldDefaultId}`);

  /**
   * @description Publishes a default data field draft if exists and unchanged
   *
   * @name PublishDefaultDataFieldDraft
   * @request POST:/v1/tenant/{tenantId}/defaults/drafts/{dataFieldDefaultId}/publish
   * @secure
   */
  publishDefaultDataFieldDraft = (
    tenantId: string,
    dataFieldDefaultId: DefaultDataFieldId,
    data: PublishDataFieldDefaultDraftDto,
    params: RequestParams = {},
  ) =>
    this.request<
      GetDataFieldDefaultPublishedDto,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/defaults/drafts/${dataFieldDefaultId}/publish`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for publishDefaultDataFieldDraft */
  publishDefaultDataFieldDraftPathGetter = (tenantId: string, dataFieldDefaultId: DefaultDataFieldId) =>
    this.getServicePath(`/v1/tenant/${tenantId}/defaults/drafts/${dataFieldDefaultId}/publish`);

  /**
   * @description Returns all data field references
   *
   * @name GetAllDataFieldReferences
   * @request GET:/v1/tenant/{tenantId}/all-references
   * @secure
   */
  getAllDataFieldReferences = (
    tenantId: string,
    query?: {
      includeSystemFields?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ListDtoGetExternalDataFieldReferenceDto,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/all-references`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAllDataFieldReferences */
  getAllDataFieldReferencesPathGetter = (
    tenantId: string,
    query?: {
      includeSystemFields?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/all-references`, query);

  /**
   * @description added as a alternative to the usages endpoint with GET method as not every http library support it
   *
   * @tags Lease
   * @name ListResourcesWhichUseThisResourceMethodPut
   * @request PUT:/v1/tenant/{tenantId}/lease
   * @secure
   */
  listResourcesWhichUseThisResourceMethodPut = (tenantId: string, data: UsageRequestRes, params: RequestParams = {}) =>
    this.request<
      WrappedLeaseRes[],
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/lease`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listResourcesWhichUseThisResourceMethodPut */
  listResourcesWhichUseThisResourceMethodPutPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/lease`);

  /**
   * @description bulk PUT usages endpoint (GET method with body is not widely supported)
   *
   * @tags Lease
   * @name ListResourcesWhichUseQueriedResourcesMethodPut
   * @request PUT:/v1/tenant/{tenantId}/lease-by-ids
   * @secure
   */
  listResourcesWhichUseQueriedResourcesMethodPut = (
    tenantId: string,
    data: UsageBulkRequestRes,
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedLeaseRes[],
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/lease-by-ids`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listResourcesWhichUseQueriedResourcesMethodPut */
  listResourcesWhichUseQueriedResourcesMethodPutPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/lease-by-ids`);

  /**
   * @description Returns values of requested data fields
   *
   * @name GetDataFields
   * @request GET:/v1/public/tenant/{tenantId}/list
   */
  getDataFields = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      ref: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ListDtoGetExternalDataFieldReferenceDto,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/list`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getDataFields */
  getDataFieldsPathGetter = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      ref: string[];
    },
  ) => this.getServicePath(`/v1/public/tenant/${tenantId}/list`, query);

  /**
   * @description Saves values of data fields
   *
   * @name SaveDataFieldValues
   * @request POST:/v1/tenant/{tenantId}/storage/fields
   * @deprecated
   * @secure
   */
  saveDataFieldValues = (tenantId: string, data: SaveCollectedDataDto, params: RequestParams = {}) =>
    this.request<
      object,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/storage/fields`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for saveDataFieldValues */
  saveDataFieldValuesPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/storage/fields`);

  /**
   * @description Saves values of data fields for a guest
   *
   * @name SaveGuestDataFieldValues
   * @request POST:/v1/tenant/{tenantId}/storage/guest/{guestId}/data
   * @secure
   */
  saveGuestDataFieldValues = (
    tenantId: string,
    guestId: string,
    data: SaveGuestCollectedDataDto,
    params: RequestParams = {},
  ) =>
    this.request<
      object,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/storage/guest/${guestId}/data`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for saveGuestDataFieldValues */
  saveGuestDataFieldValuesPathGetter = (tenantId: string, guestId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/storage/guest/${guestId}/data`);

  /**
   * @description Aggregates guest activity
   *
   * @name SubmitGuestActivity
   * @request POST:/v1/public/tenant/{tenantId}/guest/{guestId}/activity
   */
  submitGuestActivity = (tenantId: string, guestId: string, data: GuestActivityDto, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/guest/${guestId}/activity`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for submitGuestActivity */
  submitGuestActivityPathGetter = (tenantId: string, guestId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/guest/${guestId}/activity`);
}
